import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ConfirmationPageView, DepositSidebar } from 'components';
import { useDeposit } from 'providers';
import { ROUTES } from 'routes';
import { config } from 'config';
import { TRACKING_PAGES } from 'api';
import { usePageTracking } from 'hooks';
import './Deposit.scss';

export const ConfirmationPage: React.FC = () => {
  const history = useHistory();
  const { resetDeposit } = useDeposit();
  usePageTracking(TRACKING_PAGES.CONFIRMATION_PRO);

  const handleNewDeposit = useCallback(() => {
    history.push(ROUTES.registration);
    resetDeposit();
  }, [history, resetDeposit]);

  const handleGoToAccount = useCallback(() => {
    window.location.href = config.URL_PILOT + 'annonces';
  }, []);

  return (
    <>
      <div className="container-left container-left-large">
        <ConfirmationPageView onNewDeposit={handleNewDeposit} onGoToAccount={handleGoToAccount} />
      </div>
      <div className="container-right">
        <DepositSidebar />
      </div>
    </>
  );
};
